export const GET_OPTION_TAB = 'GET_OPTION_TAB';
export const GET_SELECTION_TAB = 'GET_SELECTION_TAB';
export const RESET_STATEMENTS_MODULE_DATA = "RESET_STATEMENTS_MODULE_DATA";
